import { createHash } from 'node:crypto';
import { MaxIterationsError, MaxRetriesError, PlanningError } from '@vexalyn/shared';

export interface LoopSafetyOptions {
  maxIterations?: number;
  maxRetries?: number;
  repetitionWindow?: number;
}

export class LoopSafetyGuard {
  private iterations = 0;
  private readonly callHashes: string[] = [];
  readonly maxIterations: number;
  readonly maxRetries: number;
  readonly repetitionWindow: number;

  constructor(options: LoopSafetyOptions = {}) {
    this.maxIterations = options.maxIterations ?? 20;
    this.maxRetries = options.maxRetries ?? 3;
    this.repetitionWindow = options.repetitionWindow ?? 3;
  }

  tick(): void {
    this.iterations++;
    if (this.iterations > this.maxIterations) throw new MaxIterationsError(this.maxIterations);
  }

  checkRetries(retries: number): void {
    if (retries > this.maxRetries) throw new MaxRetriesError(this.maxRetries);
  }

  recordToolCall(tool: string, input: unknown): void {
    const hash = createHash('sha1').update(JSON.stringify({ tool, input })).digest('hex');
    this.callHashes.push(hash);
    if (this.callHashes.length > this.repetitionWindow) this.callHashes.shift();
    if (this.callHashes.length === this.repetitionWindow && this.callHashes.every((item) => item === hash)) {
      throw new PlanningError(`Blocked repeated identical tool call: ${tool}`);
    }
  }
}

